import DesktopMenu from '@/components/header/DesktopMenu';
import MobMenu from '@/components/header/MobMenu';
import { useMenus } from '@/data/menuData';
import { motion } from 'framer-motion';
import { Menu } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setScrolled] = useState(false);
  const [isVisible, setVisible] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  // 🔥 MENU DARI API
  const { menus, loading } = useMenus();

  /* ========================
   * Disable body scroll saat mobile menu open
   * ======================== */
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : 'auto';
  }, [open]);

  /* ========================
   * Scroll effect
   * ======================== */
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  /* ========================
   * Navbar appear animation
   * ======================== */
  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  // ⛔ Jangan render menu sebelum data siap
  if (loading) return null;

  return (
    <>
      <motion.header
        initial={{ y: -80, opacity: 0 }}
        animate={{
          y: isVisible ? 0 : -80,
          opacity: isVisible ? 1 : 0,
          backgroundColor: isScrolled ? '#ffffff' : 'rgba(0,0,0,0.05)',
        }}
        transition={{ duration: 0.3, ease: 'easeInOut' }}
        className={`h-16 lg:h-20 text-sm md:text-base font-semibold fixed inset-0 flex-center z-50 backdrop-blur-sm ${
          isScrolled ? 'text-black' : 'text-white'
        }`}
      >
        <nav className="w-full px-5 lg:w-10/12 max-w-screen-2xl mx-auto flex-center-between">
          {/* LOGO */}
          <Link to="/">
            <motion.img
              key={isScrolled ? 'logo-dark' : 'logo-light'}
              src={isScrolled ? '/logo/akr-logo-1.webp' : '/logo/akr-logo-3.webp'}
              alt="Koperasi AKR Syariah Logo"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5 }}
              className="h-7 sm:h-8 w-auto cursor-pointer"
            />
          </Link>

          {/* DESKTOP MENU */}
          <ul className="gap-x-1 lg:flex-center hidden">
            {menus.map((menu) => (
              <DesktopMenu key={menu.name} menu={menu} pathname={pathname} />
            ))}
          </ul>

          {/* MOBILE BUTTON */}
          <motion.button
            onClick={() => setOpen(true)}
            whileTap={{ scale: 0.9 }}
            className="lg:hidden p-2"
          >
            <Menu size={25} />
          </motion.button>
        </nav>
      </motion.header>

      {/* MOBILE MENU */}
      <MobMenu open={open} setOpen={setOpen} menus={menus} pathname={pathname} />
    </>
  );
}
